module.exports = __webpack_public_path__ + "static/media/trend-up.03d2876b.svg";